export const blockIconsPrivacyandsecurityAdminPanelSettingsNew = (
	<span className='material-symbols-outlined'>admin_panel_settings</span>
);
